import { formatLanguageString } from '@itslearning/atlas/strings/format.js';

/**
 * Get course title for page
 * @param {string} courseCode
 * @param {string} courseTitle
 * @param {object} i18n
 */
export function getCourseTitle(courseCode, courseTitle, i18n) {
    return courseCode
        ? formatLanguageString(i18n.course_information_Table_header_X_Y, courseTitle, courseCode)
        : courseTitle;
}
